import checkout from "./form";

const {
  formField: { domain, apiKey, url },
} = checkout;

export default {
  [domain.name]: "",
  [apiKey.name]: "",
  [url.name]: "",
};
